import { Mail, Phone, MapPin, Clock } from 'lucide-react';

export default function ContactUs() {
  return (
    <div className="contact-us-page">
      <div className="contact-us-container">
        {/* Header */}
        <div className="contact-us-header">
          <h1>Contact Us</h1>
          <p>We'd love to hear from you. Get in touch with our team.</p>
        </div>

        <div className="contact-us-content">
          {/* Contact Form */}
          <div className="contact-us-form-section">
            <h2>Send us a Message</h2>
            <div className="contact-us-form">
              <div className="contact-us-form-group">
                <label>Full Name</label>
                <input type="text" placeholder="John Doe" />
              </div>

              <div className="contact-us-form-group">
                <label>Email Address</label>
                <input type="email" placeholder="john@example.com" />
              </div>

              <div className="contact-us-form-group">
                <label>Phone Number</label>
                <input type="tel" placeholder="+1 234 567 8900" />
              </div>

              <div className="contact-us-form-group">
                <label>Subject</label>
                <input type="text" placeholder="How can we help?" />
              </div>

              <div className="contact-us-form-group">
                <label>Message</label>
                <textarea rows="6" placeholder="Your message here..."></textarea>
              </div>

              <button className="contact-us-submit-btn">Send Message</button>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-us-info-section">
            <h2>Get in Touch</h2>

            <div className="contact-us-info-card">
              <Mail className="contact-us-icon" />
              <div>
                <h3>Email</h3>
                <p>support@example.com</p>
              </div>
            </div>

            <div className="contact-us-info-card">
              <Phone className="contact-us-icon" />
              <div>
                <h3>Phone</h3>
                <p>+1 (234) 567-8900</p>
              </div>
            </div>

            <div className="contact-us-info-card">
              <MapPin className="contact-us-icon" />
              <div>
                <h3>Address</h3>
                <p>123 Business Street, Suite 100<br />City, State 12345</p>
              </div>
            </div>

            <div className="contact-us-info-card">
              <Clock className="contact-us-icon" />
              <div>
                <h3>Business Hours</h3>
                <p>Monday - Friday: 9:00 AM - 6:00 PM<br />Saturday: 10:00 AM - 4:00 PM</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

